import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Polling } from './polling.interface';

export interface PollingState {
   [key: string]: NodeJS.Timer;
}

const PollingStore: Module<PollingState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      ADD_POLLING(state, payload: Polling) {
         const { key, callback = () => console.info('Polling triggerd'), intervalMs = 1000 } = payload;

         if (state[key]) clearInterval(state[key]);
         callback();
         state[key] = setInterval(callback, intervalMs);
      },
      STOP_POLLING(state, key: string) {
         if (state[key]) {
            clearInterval(state[key]);
         }
      },
   },
   actions: {
      startPolling(context, polling: Polling) {
         context.commit('ADD_POLLING', polling);
      },
      stopPolling(context, key: string) {
         context.commit('STOP_POLLING', key);
      },
   },
};

export default PollingStore;
